import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const VehicleOptions = ({ vehicles, onSelectVehicle }) => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const handleSelectVehicle = (vehicle) => {
    setSelectedVehicle(vehicle?.id);
    onSelectVehicle(vehicle);
  };

  return (
    <div className="space-y-4 sm:space-y-5 md:space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
        <h2 className="text-xl sm:text-2xl md:text-3xl font-heading font-bold text-foreground">
          Choose Your Vehicle
        </h2>
        <div className="flex items-center gap-2 text-xs sm:text-sm text-muted-foreground">
          <Icon name="Shield" size={14} className="text-primary sm:w-4 sm:h-4" />
          <span>All vehicles verified</span>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5 md:gap-6">
        {vehicles?.map((vehicle) => (
          <div
            key={vehicle?.id}
            className={`relative bg-card rounded-xl border-2 transition-all duration-200 overflow-hidden touch-manipulation ${
              selectedVehicle === vehicle?.id
                ? 'border-primary shadow-lg scale-105'
                : 'border-border hover:border-primary/50 hover:shadow-md'
            }`}
          >
            {vehicle?.popular && (
              <div className="absolute top-2 sm:top-3 right-2 sm:right-3 z-10 px-2 sm:px-3 py-0.5 sm:py-1 bg-accent text-accent-foreground rounded-full text-xs font-semibold">
                Most Popular
              </div>
            )}
            
            <div className="aspect-[4/3] overflow-hidden bg-muted">
              <Image
                src={vehicle?.image}
                alt={vehicle?.imageAlt}
                className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
              />
            </div>
            
            <div className="p-4 sm:p-5 md:p-6 space-y-3 sm:space-y-4">
              <div>
                <h3 className="text-base sm:text-lg md:text-xl font-heading font-semibold text-foreground mb-1">
                  {vehicle?.name}
                </h3>
                <p className="text-xs sm:text-sm text-muted-foreground">{vehicle?.type}</p>
              </div>
              
              <div className="grid grid-cols-2 gap-2 sm:gap-3">
                <div className="flex items-center gap-1.5 sm:gap-2">
                  <Icon name="Users" size={14} className="text-primary sm:w-4 sm:h-4" />
                  <span className="text-xs sm:text-sm text-foreground">{vehicle?.capacity} Seats</span>
                </div>
                <div className="flex items-center gap-1.5 sm:gap-2">
                  <Icon name="Briefcase" size={14} className="text-primary sm:w-4 sm:h-4" />
                  <span className="text-xs sm:text-sm text-foreground">{vehicle?.luggage} Bags</span>
                </div>
              </div>
              
              <div className="flex flex-wrap gap-1.5 sm:gap-2">
                {vehicle?.features?.map((feature, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-1 px-2 py-1 bg-muted rounded-md"
                  >
                    <Icon name="Check" size={10} className="text-primary" />
                    <span className="text-xs text-foreground">{feature}</span>
                  </div>
                ))}
              </div>
              
              <div className="pt-3 sm:pt-4 border-t border-border space-y-2 sm:space-y-3">
                <div className="flex items-baseline justify-between">
                  <div>
                    <p className="text-xs text-muted-foreground">Starting from</p>
                    <p className="text-xl sm:text-2xl md:text-3xl font-bold text-foreground">
                      ₹{vehicle?.price?.toLocaleString('en-IN')}
                    </p>
                  </div>
                  {vehicle?.discount && (
                    <div className="text-right">
                      <p className="text-xs text-muted-foreground line-through">
                        ₹{vehicle?.originalPrice?.toLocaleString('en-IN')}
                      </p>
                      <p className="text-xs sm:text-sm font-semibold text-success">
                        Save {vehicle?.discount}%
                      </p>
                    </div>
                  )}
                </div>
                
                <button
                  onClick={() => handleSelectVehicle(vehicle)}
                  className={`w-full py-2.5 sm:py-3 rounded-lg font-semibold text-xs sm:text-sm transition-all duration-200 touch-manipulation ${
                    selectedVehicle === vehicle?.id
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-foreground hover:bg-primary hover:text-primary-foreground active:scale-95'
                  }`}
                >
                  {selectedVehicle === vehicle?.id ? 'Selected' : 'Select Vehicle'}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VehicleOptions;